import { IonLabel, IonRange } from '@ionic/react';
import {
  ControlProps,
  ControlState,
  isRangeControl,
  rankWith,
} from '@jsonforms/core';
import { Control, withJsonFormsControlProps } from '@jsonforms/react';
import { IonItem } from '../../ionic/IonItem';
class IonicRangeControlInner extends Control<ControlProps, ControlState> {
  render() {
    const { data, enabled, label, visible, handleChange, path, schema } =
      this.props;

    const className = visible === false ? 'ion-hide' : '';

    return (
      <IonItem lines={'full'} className={className}>
        <IonLabel position="floating" color="primary">
          {label}
        </IonLabel>
        <IonRange
          pin={true}
          value={data}
          disabled={!enabled}
          min={schema.minimum}
          max={schema.maximum}
          onIonChange={(e) => {
            if (e.detail.value !== undefined) {
              handleChange(path, e.detail.value);
            }
          }}
        />
      </IonItem>
    );
  }
}

const IonicRangeTester = rankWith(10, isRangeControl);
const IonicRangeControl = withJsonFormsControlProps(IonicRangeControlInner);
export { IonicRangeControl, IonicRangeTester };
